import { fetchPriceRequest } from "actions";
import BBAPrice from "assets/img/icons/bba.png";
import classNames from "classnames";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers";
import { AppDispatch } from "store";

const Price = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { price } = useSelector((state: RootState) => state.price);

  useEffect(() => {
    dispatch(fetchPriceRequest());
  }, [dispatch]);

  return (
    <div className="relative z-10 hidden rounded-[10px] bg-gray-100 px-3 py-2 shadow-md shadow-gray-700/5 dark:bg-lightGrey dark:text-white md:flex">
      <img className="mr-3 h-6 w-6" src={BBAPrice} alt="BBA Price" />
      <span className="text-medium mr-1.5 flex items-center">
        ${price.price.toFixed(2)}
      </span>
      <span
        className={classNames(
          "text-medium mr-2 flex items-center",
          price.percent_change_1h >= 0 ? "text-green-900" : "text-red-500"
        )}
      >
        {price.percent_change_1h > 0 && "+"}
        {price.percent_change_1h.toFixed(2)}%
      </span>
      <span className="text-medium mr-2 flex items-center">|</span>
      <span className="text-medium mr-1.5 flex items-center">Fee:</span>
      <span className="text-medium mr-1.5 flex items-center text-green-900">
        0.000001 BBA
      </span>
    </div>
  );
};

export default Price;
